import { createStore } from 'effector';
import { logoutSucceeded } from '~/entities/auth';
import { PayoutOrderPublicStatus } from '~/entities/payout';
import { resetFilters, setFilters } from './events';
import { type Filters } from './types';

const initial: Filters = {
    orderId: {
        value: undefined,
    },
    requisiteType: 'card',
    requisiteSuffixes: [],
    publicStatuses: [PayoutOrderPublicStatus.PUBLIC_STATUS_COMPLETED, PayoutOrderPublicStatus.PUBLIC_STATUS_FAILED],
};

export const $filters = createStore<Filters>(initial)
    .reset([resetFilters, logoutSucceeded])
    .on(setFilters, (source, payload) => {
        return { ...source, ...payload };
    });
